import React, { useCallback, useEffect, useState } from 'react';
import classNames from './EditContainer.module.scss';
import classes from 'classnames';
import SVG from 'react-inlinesvg';
import clearIcon from '@/assets/svg/close.svg';

interface TextFieldProps {
  value?: string;
  error?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

const TextField = ({ value, error, disabled = false, onChange }: TextFieldProps) => {
  const [valueState, setValueState] = useState<string>('');

  useEffect(() => {
    setValueState(value ?? '');
  }, [value]);

  const onChangeHandler = useCallback(
    (event: any) => {
      const value = event?.target?.value ?? '';
      setValueState(value);
      if (onChange) {
        onChange(value);
      }
    },
    [onChange]
  );

  const onClearHandler = useCallback(() => {
    setValueState('');
    if (onChange) {
      onChange('');
    }
  }, [onChange]);

  return (
    <div
      className={classes(classNames.textField, {
        [classNames.textFieldError]: !!error,
      })}
    >
      <input value={valueState} onChange={onChangeHandler} disabled={disabled} />
      {valueState && !disabled && <SVG src={clearIcon} onClick={onClearHandler} />}
    </div>
  );
};

export default TextField;
